import { SlidersHorizontal } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useDensity, type DensityPreference } from '@/theme/use-density';
import { cn } from '@/lib/cn';

export function DensityControl({ className }: { className?: string }) {
  const { preference, setDensity } = useDensity();
  const { t } = useTranslation('common');
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={cn('shrink-0', className)}
          aria-label={t('density.label')}
          title={t('density.label')}
        >
          <SlidersHorizontal className="h-4 w-4" aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuRadioGroup
          value={preference}
          onValueChange={(v) => setDensity(v as DensityPreference)}
        >
          {(['auto', 'comfortable', 'compact'] as const).map((option) => (
            <DropdownMenuRadioItem className="min-h-11" key={option} value={option}>
              {t(`density.${option}`)}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
